// extracted by mini-css-extract-plugin
export default {"embla__viewport":"embla__viewport","embla__container":"embla__container","embla__slide":"embla__slide"};